import { onUnmounted, ref } from 'vue';

const inputLockCssClass = 'page-lock';

const keyboardInterceptor = (event) => {
  event.preventDefault();
};

const useUILockHook = (
  {
    targetElementTemplateRef = null,
    targetElementSelector = 'body',
  } = {},
) => {
  const uiLocked = ref(false);

  const getTargetElement = () => targetElementTemplateRef?.value || document.querySelector(targetElementSelector);

  const setUILockState = (value) => {
    uiLocked.value = value;

    const targetElement = getTargetElement();

    if (targetElement) {
      if (value) {
        document.activeElement?.blur?.();

        targetElement.classList.add(inputLockCssClass);
        document.addEventListener('keydown', keyboardInterceptor);
      } else {
        targetElement.classList.remove(inputLockCssClass);
        document.removeEventListener('keydown', keyboardInterceptor);
      }
    }
  };

  onUnmounted(() => {
    const targetElement = getTargetElement();

    if (targetElement?.classList?.contains?.(inputLockCssClass)) {
      targetElement.classList.remove(inputLockCssClass);
    }

    document.removeEventListener('keydown', keyboardInterceptor);
  });

  return [
    uiLocked,
    setUILockState,
  ];
};

export default useUILockHook;
